/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EnterDemoSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type EnterDemoRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type EnterDemoResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type EnterDemoSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const EnterDemoSecurity$outboundSchema: z.ZodMiniType<
  EnterDemoSecurity$Outbound,
  EnterDemoSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function enterDemoSecurityToJSON(
  enterDemoSecurity: EnterDemoSecurity,
): string {
  return JSON.stringify(
    EnterDemoSecurity$outboundSchema.parse(enterDemoSecurity),
  );
}

/** @internal */
export type EnterDemoRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const EnterDemoRequest$outboundSchema: z.ZodMiniType<
  EnterDemoRequest$Outbound,
  EnterDemoRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function enterDemoRequestToJSON(
  enterDemoRequest: EnterDemoRequest,
): string {
  return JSON.stringify(
    EnterDemoRequest$outboundSchema.parse(enterDemoRequest),
  );
}

/** @internal */
export const EnterDemoResponse$inboundSchema: z.ZodMiniType<
  EnterDemoResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function enterDemoResponseFromJSON(
  jsonString: string,
): SafeParseResult<EnterDemoResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnterDemoResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnterDemoResponse' from JSON`,
  );
}
